import * as XLSX from "xlsx";
import { normalizeItemKey } from "../models/salesRecord";

function normHeader(h) {
  return String(h ?? "")
    .trim()
    .toLowerCase()
    .replace(/[\s_]+/g, "");
}

const HEADER_ALIASES = {
  itemname: "itemName",
  item: "itemName",
  productname: "itemName",
  name: "itemName",
  currentstock: "currentStock",
  stock: "currentStock",
  qtyonhand: "currentStock",
  branchname: "branchName",
  branch: "branchName",
};

/**
 * Parse stock forecast Excel upload.
 * @returns {Promise<{ items: Array<{ itemName: string, currentStock: number|null, branchName: string }>, errors: string[] }>}
 */
export async function parseStockForecastExcel(file) {
  if (!file) throw new Error("No file selected.");

  const buffer = await file.arrayBuffer();
  const workbook = XLSX.read(buffer, { type: "array" });
  const sheet = workbook.Sheets[workbook.SheetNames[0]];
  if (!sheet) throw new Error("Excel file has no sheets.");

  const rawRows = XLSX.utils.sheet_to_json(sheet, { defval: "" });
  if (!rawRows.length) throw new Error("Excel sheet is empty.");

  const errors = [];
  const seen = new Set();
  const items = [];

  for (let i = 0; i < rawRows.length; i += 1) {
    const raw = rawRows[i];
    const mapped = {};
    for (const [key, val] of Object.entries(raw)) {
      const nk = normHeader(key);
      const field = HEADER_ALIASES[nk] || nk;
      mapped[field] = val;
    }

    const itemName = String(mapped.itemName ?? mapped.itemname ?? "").trim();
    if (!itemName) {
      errors.push(`Row ${i + 2}: missing ItemName`);
      continue;
    }

    const key = normalizeItemKey(itemName);
    if (seen.has(key)) continue;
    seen.add(key);

    let currentStock = null;
    if (mapped.currentStock !== "" && mapped.currentStock != null) {
      const n = Number(String(mapped.currentStock).replace(/,/g, ""));
      currentStock = Number.isFinite(n) ? n : null;
    }

    const branchName = String(mapped.branchName ?? mapped.branch ?? "").trim();

    items.push({ itemName, currentStock, branchName });
  }

  if (!items.length) {
    throw new Error("No valid rows with ItemName found.");
  }

  return { items, errors };
}

/** Template download for users. */
export function downloadForecastTemplate() {
  const ws = XLSX.utils.aoa_to_sheet([
    ["ItemName", "CurrentStock", "BranchName"],
    ["Example Filter", "10", "Main"],
  ]);
  const wb = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(wb, ws, "StockForecast");
  XLSX.writeFile(wb, "stock_forecast_template.xlsx");
}
